class LargeLookbookWithShowAll extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.showAllBtn = this.querySelector('[data-show-all-lookbook]');
            this.lookbookImage = this.querySelector('[data-lookbook-image]');
            if (this.showAllBtn) {
                this.showAllBtn.addEventListener('click', this.toggleShowAll.bind(this));
            }
        }
        toggleShowAll() {
            this.lookbookImage.classList.toggle('show-all');
        }
    }
    customElements.define('large-lookbook-with-show-all', LargeLookbookWithShowAll);